<wm-common-dynamic-table
  [rows]="rows"
  [columns]="columns"
  [availableWorkflows]="availableWorkflows"
  [entities]="cellDropdownEntities"
  [dataSetConfig]="dataSetConfig"
  [isNoData]="isNoData"
  [hasFewData]="hasFewData"
  [workflowDisplayNameFn]="workflowDisplayNameResolver"
  (addWorkflowRequested)="addWorkflow()"
  (deleteWorkflowRequested)="deleteWorkflow($event)"
  (workflowSelected)="selectWorkflow($event.index, $event.workflow)"
  (columnSettingsRequested)="openColumnSettings()"
  (columnEditRequested)="editColumn($event)"
  (columnDeleteRequested)="deleteColumnByColumn($event)"
  (columnMoveLeftRequested)="moveColumnLeft($event)"
  (columnMoveRightRequested)="moveColumnRight($event)"
  (columnReordered)="reorderColumn($event)"
  (cellDropdownOpened)="openCellDropdown($event.row, $event.column)"
  (cellEntitySelected)="selectCellEntity($event.row, $event.column, $event.entity)"
  (cellValueDeleted)="deleteCellValue($event.row, $event.column, $event.index)"
  (rowFiltersChanged)="onRowFiltersChange2($event.event, $event.row)">
</wm-common-dynamic-table>
